/// maksājumu pieteikuma apstrāde

angular.module("myApp").controller(
  "MaksajumsFormController",
  function MaksajumsFormController(
    $scope,
    $state,
    $controller,
    $http,
    $stateParams,
    $filter,

    MpSaveMaindata,
    MpSaveIstenosana,
    MpEditProblema,
    MpRemoveProblema,
    MpSavePasakumi,
    MpEditIepirkumaLigums,
    MpRemoveIepirkumaLigums,
    MpEditDarbaLigums,
    MpRemoveDarbaLigums,
    MpSaveIznakumaRaditaji,
    MpSaveRezultataRaditaji,
    MpSaveMerkis,
    MpAttachFile,
    MpSubmit,
    MpRemoveAttachment,
    MpImprove,
    MpAccept,
    MpReject,
    MpUnsubmit,
    MpSetStatus,
    MpSaveCfla,
    MpEditIzdevums,
    MpRemoveIzdevums,
    MpEditStdIzdevums,
    MpRemoveStdIzdevums,
    MpEditNatura,
    MpRemoveNatura,
    MpDelete,
    MpSaveKopsavilkums,
    MpSaveLzpKopsavilkums,
    MpRefreshKopsavilkums,
    authentication,

    Notification,
    uuiData,
    Codifiers,
    Dialog,
    Upload
  ) {
    const i = (n) => {
      const normalized = String(n).replace(/,/g, ".").replace(/[ ]/g, "")
      const parsed = Number.parseFloat(normalized)
      return Number.isNaN(parsed) ? 0 : parsed
    }

    $controller("BaseEditController", { $scope })
    $scope.dto_view = "maksajuma_pieteikums"
    $scope.editable = false
    $scope.editable_attachments = false
    $scope.submittable = false

    $scope.kla = Codifiers.kla
    $scope.locks = {}
    $scope.edit = {}

    const ceturksni = ["1", "2", "3", "4"]
    let dto

    this.tabs = []

    $scope.upload = {
      file: undefined,
      desc: undefined,
    }

    const pageTitle = (n, s) => {
      if (s.length > 50) {
        let max = 47
        while (max < s.length && s[max] !== " ") max++
        s = `${s.substring(0, max)}...`
      }
      if (n) {
        const ns = n.split("/")
        return `${ns[ns.length - 1]} ${s}`
      }
      return s
    }

    const percentize = $scope.percentize

    $scope.afterLoad = () => {
      dto = $scope.dto
      if (this.tabs.length === 0) {
        Codifiers.kla.mp_tabs.forEach((t) => {
          if (t.only_manager === true && !authentication.u.is.manager) {
            // avoid
          } else if (t.only_admin === true && !authentication.u.is.admin) {
            // avoid
          } else if (t.konkurss && -1 === t.konkurss.indexOf(dto.konkurss)) {
            console.log({ avoiding: t, konkurss: dto.konkurss })
            // avoid
          } else if (t.pieprasijuma_veidi && -1 === t.pieprasijuma_veidi.indexOf(dto.pieprasijuma_veids)) {
            console.log({ avoiding: t, pieprasijuma_veids: dto.pieprasijuma_veids })
          } else {
            let visible = true
            if (typeof t.visible === "boolean") {
              visible = t.visible
            }
            this.tabs.push({
              ...t,
              visible,
            })
          }
        })
      }
      this.tabs.forEach((t) => {
        if (t.visible_fn) {
          t.visible = t.visible_fn(dto)
        }
      })

      window.document.title = `${pageTitle(dto.numurs, dto.nosaukums)} - Postdoc`

      // LZP_OK īpaši neafišē
      if (dto.statuss === "LZP_OK" && !$scope.u.is.manager) dto.statuss = "IZSKATISANA"

      const statuss = dto.statuss
      if (statuss === "DZESTS") {
        $state.go(this.goodBackState())
      }
      $scope.ir_melnraksts = statuss === "MELNRAKSTS" || statuss === "MELNRAKSTS-LABOJUMS"
      $scope.is_operational =
        $scope.u.is.organization_iesniedzejs || !$scope.u.is.manager || dto.ir_lzp_ievadits
      $scope.editable =
        $scope.ir_melnraksts &&
        ($scope.u.is.organization_iesniedzejs || !$scope.u.is.manager || dto.ir_lzp_ievadits)
      $scope.editable_attachments = $scope.u.is.manager
      $scope.submittable =
        $scope.ir_melnraksts &&
        ($scope.u.is.organization_iesniedzejs || ($scope.u.is.manager && dto.ir_lzp_ievadits))

      if (dto.parskata_sakuma_datums) dto.parskata_sakuma_datums = new Date(dto.parskata_sakuma_datums)
      if (dto.parskata_beigu_datums) dto.parskata_beigu_datums = new Date(dto.parskata_beigu_datums)

      dto.js_pieteikums_state = $scope.u.is.manager ? "app.submissions.edit" : "app.application.edit"

      // reference uz klasifikatoriem
      dto.kla_budzets = dto.ar_saimniecisku_darbibu_saistits
        ? Codifiers.kla.budzets_saimn
        : Codifiers.kla.budzets_generic

      dto.rev_pieteikuma_darbibas = {}
      dto.pieteikuma_darbibas.forEach((d) => {
        dto.rev_pieteikuma_darbibas[d.id] = d
      })

      // predefinēti, līdzīgi kā pp.js, un atkarīgi (šobrīd) no projekta iesniegšanas gada
      // iespējams, ka vajag 2017, 2018, 2020, 2023
      // nākamgad iesniegtajiem projektiem būs savādā, bet neviens nezina, kā tieši
      const sakuma_gads = dto.sakuma_gads
      dto.js_ieklautie_gadi = [
        sakuma_gads,
        sakuma_gads + 1,
        sakuma_gads + 2,
        sakuma_gads + 3,
        sakuma_gads + 4,
      ].map((s) => `${s}`)

      const blank_data = {}
      dto.js_ieklautie_gadi.forEach((gads) => {
        blank_data[gads] = {
          total: 0,
          1: undefined,
          2: undefined,
          3: undefined,
          4: undefined,
        }
      })

      // TAB-ISTENOSANA
      // No pieteikuma: pieteikuma_darbibas -> pieteikuma_rezultati
      // katrā vajag iekšā objektu "mp_rezultati",
      // ja MP ir rezultāti, tad tie ir iekš dto.darbibas_rezultati
      dto.pieteikuma_darbibas.forEach((pd) => {
        const mp_darbibas_info = dto.darbibas.find((d) => d.pv_darbiba_id === pd.id)
        pd.pasakums = mp_darbibas_info ? mp_darbibas_info : {}

        pd.pieteikuma_rezultati.forEach((pr) => {
          pr.mp_rezultati = angular.copy(blank_data)
          dto.darbibas_rezultati.forEach((e) => {
            if (e.pv_darbiba_id === pd.id && e.pv_darbibas_rezultats_id === pr.id && e.gads) {
              pr.mp_rezultati[e.gads][e.ceturksnis] = e.skaits
            }
          })
          this.updateTotal(pr.mp_rezultati)
        })
      })

      dto.pieteikuma_iznakumi.forEach((d) => {
        d.rezultati = angular.copy(blank_data)
        d.pasakums = {}
      })

      dto.iznakuma_raditaji.forEach((d) => {
        // ieliek saiti uz atbilstošo mp_darbiba ierakstu iekšā actual pv darbībās
        const pd = dto.pieteikuma_iznakumi.find((pd) => pd.id === d.pv_iznakuma_raditajs_id)
        if (pd) {
          pd.pasakums = d

          d.rezultati.forEach((r) => {
            if (!!r.gads && r.gads !== "total") {
              if (pd.rezultati[r.gads] === undefined) {
                console.log(`pieteikuma_iznakumi: adding entry for ${r.gads}`)
                pd.rezultati[r.gads] = {}
              }
              pd.rezultati[r.gads][r.ceturksnis] = r.skaits
            }
          })

          this.updateTotal(pd.rezultati)
        }
      })

      dto.pieteikuma_rezultata_raditaji.forEach((d) => {
        d.rezultati = angular.copy(blank_data)
        d.pasakums = {}
      })
      dto.rezultata_raditaji.forEach((d) => {
        // ieliek saiti uz atbilstošo mp_darbiba ierakstu iekšā actual pv darbībās
        const pd = dto.pieteikuma_rezultata_raditaji.find((pd) => pd.id === d.pv_rezultata_raditajs_id)
        if (pd) {
          pd.pasakums = d
          d.rezultati.forEach((r) => {
            if (!!r.gads && r.gads !== "total") {
              if (pd.rezultati[r.gads] === undefined) {
                console.log(`pieteikuma_rezultata_raditaji: adding entry for ${r.gads}`)
                pd.rezultati[r.gads] = {}
              }
              pd.rezultati[r.gads][r.ceturksnis] = r.skaits
            }
          })
          this.updateTotal(pd.rezultati)
        }
      })

      dto.std_izdevumi_total = 0
      dto.std_izdevumi.forEach((izd) => {
        dto.std_izdevumi_total += i(izd.attiec_izdevumi)
      })

      dto.izdevumi_pers_total = 0
      dto.izdevumi_total = { kopeja_summa: 0, attiec_izdevumi: 0, attiec_pvn: 0 }

      dto.izdevumi.forEach((izd) => {
        dto.izdevumi_total.kopeja_summa += i(izd.kopeja_summa)
        dto.izdevumi_total.attiec_izdevumi += i(izd.attiec_izdevumi)
        dto.izdevumi_total.attiec_pvn += i(izd.attiec_pvn)
        if (izd.budzeta_sadalas_kods === "pers") {
          dto.izdevumi_pers_total += i(izd.kopeja_summa)
        }
      })

      dto.pieteikuma_publicitate.forEach((pub) => {
        const p = dto.pasakumi.find((p) => pub.id === p.pv_publicitate_id)
        if (p) {
          pub.pasakums = p
        } else {
          pub.pasakums = {}
        }
      })

      update_kopsavilkums()
    }

    const update_kopsavilkums = () => {
      const fields = [
        "izdevumi_apstipr",
        "izdevumi_prev",
        "izdevumi_this",
        "izdevumi_total",
        "izdevumi_lzp_apstiprinats",
        "izdevumi_lzp_apstiprinats_kopa",
      ]
      // pārsortējam attiecināmo izdevumu kopsavilkumu
      {
        let sadalas
        if (dto.ar_saimniecisku_darbibu_saistits) {
          sadalas = Codifiers.kla.budzeta_sadalas_saimniecisks
        } else {
          sadalas = Codifiers.kla.budzets_generic
        }
        const attiec_order = sadalas.map((q) => q.id)
        const sadalas_rev = Object.fromEntries(sadalas.map((s) => [s.id, s]))
        const attiec_idx = Object.fromEntries(attiec_order.map((k, i) => [k, i]))
        dto.kopsavilkums_attiec = dto.kopsavilkums_attiec
          .sort((a, b) => attiec_idx[a.kods] - attiec_idx[b.kods])
          .map((s) => ({
            ...s,
            nosaukums: sadalas_rev[s.kods].nosaukums,
            sadala: sadalas_rev[s.kods].sadala,
          }))

        // denullē visus skaitļus
        dto.kopsavilkums_attiec.forEach((k) => {
          fields.forEach((f) => {
            if (k[f]) {
              k[f] = i(k[f])
            }
          })
        })

        // totālim skaitām kopā tikai "lielās" sadaļas
        dto.kopsavilkums_attiec_total = {}
        sadalas
          .filter((s) => s.is_major)
          .forEach((s) => {
            const k = dto.kopsavilkums_attiec.find((e) => e.kods === s.id)
            if (k) {
              fields.forEach((f) => {
                dto.kopsavilkums_attiec_total[f] = i(dto.kopsavilkums_attiec_total[f]) + i(k[f])
              })
            }
          })
      }

      // Sadalījums pa finansējuma avotiem

      // kopsavilkumā atstāsim tikai tos laukus, kuri ir ACTUALLY nepieciešami
      let sadalas
      let header_fields
      if (dto.ar_saimniecisku_darbibu_saistits) {
        sadalas = Codifiers.kla.saimn_finansejuma_avoti
        header_fields = ["total_eraf", "total_priv"]
      } else {
        sadalas = Codifiers.kla.finansejuma_avoti
        header_fields = ["eraf", "budget", "other"]
      }

      const sadal_names = Object.fromEntries(sadalas.map((s) => [s.id, s.nosaukums]))
      const sadal_order = sadalas.map((q) => q.id)
      const sadal_idx = Object.fromEntries(sadal_order.map((k, i) => [k, i]))
      dto.kopsavilkums_sadalijums = dto.kopsavilkums_sadalijums
        .filter((s) => !!sadal_names[s.kods])
        .sort((a, b) => sadal_idx[a.kods] - sadal_idx[b.kods])
        .map((s) => ({ ...s, nosaukums: sadal_names[s.kods], is_header: header_fields.includes(s.kods) }))

      dto.kopsavilkums_sadalijums_total = {}
      dto.kopsavilkums_sadalijums.forEach((k) => {
        if (header_fields.includes(k.kods)) {
          fields.forEach((f) => {
            if (k[f]) {
              k[f] = i(k[f])
            }
            dto.kopsavilkums_sadalijums_total[f] = i(dto.kopsavilkums_sadalijums_total[f]) + i(k[f])
          })
        }
      })
    }

    $scope.save = (part) => {
      if (part === "maindata") {
        return this.mp_save_maindata()
      } else if (part === "istenosana") {
        return this.mp_save_istenosana()
      } else if (part === "publicitate") {
        return this.mp_save_publicitate()
      } else if (part === "iznakums") {
        return this.mp_save_iznakumi()
      } else if (part === "iznakums_lzp") {
        return this.mp_save_iznakumi_lzp()
      } else if (part === "rezultati") {
        return this.mp_save_rezultati()
      } else if (part === "merkis") {
        return this.mp_save_merkis()
      } else if (part === "kopsavilkums") {
        return this.mp_save_kopsavilkums(false)
      } else if (part === "lzp_kopsavilkums") {
        return this.mp_save_kopsavilkums(true) // tas pats, tikai caur LZP endpointu, jo drīkst vienmēr
      } else {
        Notification.error(`Programmas kļūda: kodā nav atrodama sadaļas "${part}" saglabāšana.`)
      }
    }

    this.once_after_save = undefined // callbacks pēs saglabāšanas

    this.mp_save_kopsavilkums_lzp = () => {
      const d = {
        id: dto.id,
        attiec: dto.kopsavilkums_attiec,
        sadalijums: dto.kopsavilkums_sadalijums,
      }
      this.saveTab(new MpSaveLzpKopsavilkums(d))
    }

    this.mp_save_kopsavilkums = (lzp_mode = false) => {
      update_kopsavilkums()
      if (lzp_mode) {
        return this.mp_save_kopsavilkums_lzp()
      }

      const d = {
        id: dto.id,
        sadalijums: dto.kopsavilkums_sadalijums,
      }
      this.saveTab(new MpSaveKopsavilkums(d))
    }

    this.mp_save_publicitate = () => {
      const d = {
        id: dto.id,
        pasakumi: [],
      }
      dto.pieteikuma_publicitate.forEach((pp) => {
        const p = pp.pasakums

        if (p.veiktie_pasakumi || p.istenosanas_periods || p.skaits) {
          d.pasakumi.push({
            id: p.id,
            pv_publicitate_id: pp.id,
            veiktie_pasakumi: p.veiktie_pasakumi,
            istenosanas_periods: p.istenosanas_periods,
            skaits: p.skaits,
            skaits_kopa: p.skaits_kopa,
          })
        }
      })
      this.saveTab(new MpSavePasakumi(d))
    }

    this.mp_save_istenosana = () => {
      const d = {
        id: dto.id,
        darbibas: [],
        rezultati: [],
      }

      dto.pieteikuma_darbibas.forEach((pd) => {
        pd.pieteikuma_rezultati.forEach((pr) => {
          d.rezultati.push({
            gads: null,
            ceturksnis: null,
            skaits: pr.mp_rezultati.total,
            pv_darbiba_id: pd.id,
            pv_darbibas_rezultats_id: pr.id,
          })

          dto.js_ieklautie_gadi.forEach((gads) => {
            if (pr.mp_rezultati[gads]) {
              ceturksni.forEach((ceturksnis) => {
                let skaits = pr.mp_rezultati[gads][ceturksnis]
                if (skaits) {
                  d.rezultati.push({
                    gads,
                    ceturksnis,
                    skaits: +skaits,
                    pv_darbiba_id: pd.id,
                    pv_darbibas_rezultats_id: pr.id,
                  })
                }
              })
            }
          })
        })

        d.darbibas.push({
          pv_darbiba_id: pd.id,
          veiktie_pasakumi: pd.pasakums.veiktie_pasakumi,
          norises_vieta: pd.pasakums.norises_vieta,
          piezimes: pd.pasakums.piezimes,
        })
      })

      this.saveTab(new MpSaveIstenosana(d))
    }

    this.mp_save_iznakumi = () => {
      const d = {
        id: dto.id,
        iznakuma_raditaji: [],
      }

      dto.pieteikuma_iznakumi.forEach((pd) => {
        const rezultati = [{ gads: null, skaits: pd.rezultati.total }]
        dto.js_ieklautie_gadi.forEach((gads) => {
          ceturksni.forEach((ceturksnis) => {
            let skaits = pd.rezultati[gads][ceturksnis]
            if (skaits) {
              rezultati.push({ gads, ceturksnis, skaits })
            }
          })
        })

        d.iznakuma_raditaji.push({
          rezultati,
          pv_iznakuma_raditajs_id: pd.id,
          piezimes: pd.pasakums.piezimes,
          statistiskais_regions: pd.pasakums.statistiskais_regions,
          sasniegtie_rezultati: pd.pasakums.sasniegtie_rezultati,
          sasniegtie_rezultati_lzp: pd.pasakums.sasniegtie_rezultati_lzp,
        })
      })

      this.saveTab(new MpSaveIznakumaRaditaji(d))
    }

    this.mp_save_iznakumi_lzp = () => {
      const ds = dto.pieteikuma_iznakumi.map((r) => {
        return {
          pv_iznakuma_raditajs_id: r.id,
          iznakuma_raditaja_id: r.pasakums.id,
          sasniegtie_rezultati_lzp: r.pasakums.sasniegtie_rezultati_lzp,
        }
      })
      $scope.lzp_saving = true
      const save_iznakumi_one = (ds) => {
        if (ds.length === 0) {
          Notification.success("Saglabāts veiksmīgi!")
          $scope.reload()
          $scope.lzp_saving = false
        } else {
          $http({
            method: "POST",
            url: "/data/mp_set_sasniegtie_rezultati_lzp",
            data: {
              id: dto.id,
              ...ds[0],
            },
          })
            .then(() => {
              save_iznakumi_one(ds.slice(1))
            })
            .catch($scope.failing)
        }
      }
      save_iznakumi_one(ds)
    }

    this.mp_save_rezultati = () => {
      const d = {
        id: dto.id,
        rezultata_raditaji: [],
      }

      dto.pieteikuma_rezultata_raditaji.forEach((pd) => {
        const rezultati = [{ gads: null, skaits: pd.rezultati.total }]
        dto.js_ieklautie_gadi.forEach((gads) => {
          ceturksni.forEach((ceturksnis) => {
            const skaits = pd.rezultati[gads][ceturksnis]
            if (skaits) {
              rezultati.push({ gads, ceturksnis, skaits })
            }
          })
        })

        d.rezultata_raditaji.push({
          rezultati,
          pv_rezultata_raditajs_id: pd.id,
          piezimes: pd.pasakums.piezimes,
          statistiskais_regions: pd.pasakums.statistiskais_regions,
        })
      })

      this.saveTab(new MpSaveRezultataRaditaji(d))
    }

    this.mp_save_maindata = () => {
      const d = new MpSaveMaindata($scope.dto) // fui
      if (d.kopeja_summa) d.kopeja_summa = +d.kopeja_summa
      if (d.es_atmaksa) d.es_atmaksa = +d.es_atmaksa
      if (d.valsts_atmaksa) d.valsts_atmaksa = +d.valsts_atmaksa
      if (d.parskata_sakuma_datums)
        d.parskata_sakuma_datums = moment(d.parskata_sakuma_datums).format("YYYY-MM-DD")
      if (d.parskata_beigu_datums)
        d.parskata_beigu_datums = moment(d.parskata_beigu_datums).format("YYYY-MM-DD")
      this.saveTab(d)
    }

    this.mp_save_merkis = () => {
      const d = new MpSaveMerkis({
        id: dto.id,
        merka_sasniegsanas_apraksts: dto.merka_sasniegsanas_apraksts,
      })
      this.saveTab(d)
    }

    this.saveTab = (obj) => {
      obj.$save(
        () => {
          Notification.success("Izmaiņas saglabātas.")
          $scope.reload()
          $scope.edit = {}
          if (this.once_after_save) {
            this.once_after_save()
          }
          this.once_after_save = undefined
        },
        (err) => {
          this.once_after_save = undefined
          // eslint-disable-next-line no-console
          console.log(err)
          Notification.error(err.data ? err.data : "Neizdevās saglabāt datus.")
        }
      )
    }

    this.switchToSomeTab = (tpl_part) => {
      let match = null
      this.tabs.find((t, idx) => {
        if (!t.visible) {
          return false
        }
        if (t.name === tpl_part) {
          match = idx
          return true
        }
        if (t.name.indexOf(tpl_part) !== -1) {
          match = idx
        } else if (t.template.indexOf(tpl_part) !== -1) {
          match = idx
        }
        return false
      })
      if (match !== null) {
        this.active_tab = match
      }
    }

    this.updateTotal = (elem) => {
      elem.total = 0
      Object.keys(elem).forEach((k) => {
        if (k !== "total") {
          ceturksni.forEach((cet) => {
            if (elem[k][cet]) elem.total += +elem[k][cet]
          })
        }
      })
    }

    this.addProblema = () => this.editProblema({ riska_statuss: "NAV_NOVERSTS", new: true })
    this.addIepirkumaLigums = () => {
      this.editIepirkumaLigums({
        liguma_veids: "PAKALPOJUMA",
        statuss: "PROCESA",
        new: true,
      })
    }

    this.addDarbaLigums = () => {
      this.editDarbaLigums({
        new: true,
      })
    }

    this.addNatura = () => {
      this.editNatura({
        new: true,
      })
    }

    this.editProblema = (pp) => {
      const p = angular.copy(pp)
      Dialog.dialog("pages/dialogs/mp.problema.form.html", p, (p, action) => {
        if (action === "delete") {
          return Dialog.finish(new MpRemoveProblema({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          return Dialog.finish(new MpEditProblema(p), $scope.reload)
        }
      })
    }

    this.editIepirkumaLigums = (pp) => {
      const p = angular.copy(pp)
      p.pieteikuma_darbibas = dto.pieteikuma_darbibas
      p.kla_budzets = dto.kla_budzets
      const date_fields = [
        "izsludinajuma_datums",
        "lemuma_pub_datums",
        "parakstisanas_datums",
        "liguma_beigu_datums",
      ]
      date_fields.forEach((dat) => {
        if (p[dat]) p[dat] = new Date(p[dat])
      })

      Dialog.dialog("pages/dialogs/mp.iepirkuma-ligums.form.html", p, { wide: true }, (p, action) => {
        if (action === "delete") {
          return Dialog.finish(new MpRemoveIepirkumaLigums({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          const currency_fields = ["summa_bez_pvn", "attiec_summa_bez_pvn", "attiec_summa_ar_pvn"]
          currency_fields.forEach((c) => {
            p[c] = p[c] ? +p[c] : undefined
          })
          return Dialog.finish(new MpEditIepirkumaLigums(p), $scope.reload)
        }
      })
    }

    this.editNatura = (pp) => {
      const p = angular.copy(pp)
      p.kla_budzets = dto.kla_budzets

      Dialog.dialog("pages/dialogs/mp.natura.form.html", p, { wide: false }, (p, action) => {
        if (action === "delete") {
          return Dialog.finish(new MpRemoveNatura({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          const numeric_fields = ["kopeja_summa"]
          numeric_fields.forEach((c) => {
            p[c] = p[c] ? +p[c] : undefined
          })
          return Dialog.finish(new MpEditNatura(p), $scope.reload)
        }
      })
    }

    this.editDarbaLigums = (pp) => {
      const p = {
        ...pp,
        pieteikuma_darbibas: dto.pieteikuma_darbibas,
        budzeta_sadalas_kods: "pers",
      }

      const date_fields = ["sakuma_datums", "beigu_datums"]
      date_fields.forEach((dat) => {
        if (p[dat]) p[dat] = new Date(p[dat])
      })

      Dialog.dialog("pages/dialogs/mp.darba-ligums.form.html", p, { wide: false }, (p, action) => {
        if (action === "delete") {
          return Dialog.finish(new MpRemoveDarbaLigums({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          const currency_fields = ["darba_alga"]
          currency_fields.forEach((c) => {
            p[c] = p[c] ? +p[c] : undefined
          })
          return Dialog.finish(new MpEditDarbaLigums(p), $scope.reload)
        }
      })
    }

    this.submit = () => {
      return Dialog.dialog("pages/dialogs/mp.apliecinajums.form.html", {}, {}, (_p, action) => {
        if (action !== "save") return

        const pp = new MpSubmit({ id: dto.id })
        return Dialog.finish(pp, () => {
          $state.go(this.goodBackState(), { id: pp.id })
        })
      })
    }

    this.goodBackState = () => {
      if ($scope.u.is.manager) {
        return "app.maksajumi.list"
      }
      return "app.org-dashboard"
    }

    this.uploadAttachment = (form, pielikuma_veids) => {
      const v = new MpAttachFile()
      $scope.upload.pielikuma_veids = pielikuma_veids
      return this.actual_uploader(v, form)
    }

    this.actual_uploader = (obj, form) => {
      $scope.upload.error = undefined
      $scope.upload.loading = true
      return Upload.upload({
        url: "./upload",
        method: "POST",
        file: $scope.upload.file,
      })
        .progress((evt) => {
          $scope.upload.progress = {
            loaded: evt.loaded,
            total: evt.total,
            percentage: percentize(evt.loaded, evt.total),
          }
        })
        .success((data) => {
          obj.id = dto.id
          obj.file_id = data.id
          obj.pielikuma_veids = $scope.upload.pielikuma_veids
          obj.apraksts = $scope.upload.desc
          return obj.$save(
            () => {
              $scope.upload = {
                loading: false,
              }
              form.$setPristine()
              return $scope.reload()
            },
            (e) => {
              $scope.upload = {
                loading: false,
              }
              $scope.upload.error = e.data
              Notification.error(e.data)
            }
          )
        })
        .error((data) => {
          $scope.upload = { loading: false }
          form.$setPristine()
          if (data.indexOf("EntityStreamSizeException" > -1)) {
            $scope.upload.error = "Ielādējamais fails ir par lielu."
          } else {
            $scope.upload.error = data
          }
        })
    }

    this.removeAttachment = (a) => {
      if (!confirm("Izdzēst failu?")) return

      const d = new MpRemoveAttachment({
        id: dto.id,
        file_id: a.id,
      })
      d.$save(() => {
        Notification.success("Pielikums izdzēsts.")
        $scope.reload()
      }, $scope.failing)
    }

    this.mp_accept = () => {
      if (!confirm("Apstiprināt šo pieteikumu?")) return
      const dto = new MpAccept({ id: $stateParams.id })
      return dto.$save(() => {
        Notification.success("Maksājuma pieteikums tika apstiprināts.")
        $scope.reload()
      }, $scope.failing)
    }

    this.mp_reject = () => {
      if (!confirm("Vai noraidīt šo pieteikumu?")) return

      const dto = new MpReject({
        id: $stateParams.id,
        // piezimes: p.komentars
      })
      return dto.$save(() => {
        Notification.success("Pieteikums tika noraidīts.")
        $scope.reload()
      }, $scope.failing)
    }

    this.mp_status = (statuss) => {
      if (!confirm(`Mainīt pieteikuma statusu uz ${statuss}?`)) return
      const pp = new MpSetStatus({ id: dto.id, statuss })
      return pp.$save(() => {
        Notification.success(`Statuss nomainīts uz ${statuss}`)
        $scope.reload()
      }, $scope.failing)
    }

    this.mp_unsubmit = () => {
      if (!confirm("Atgriezt pieteikumu labošanas režīmā? Bez vēstures un jaunas versijas?")) return
      const mp = new MpUnsubmit({ id: dto.id })
      return mp.$save(() => {
        Notification.success("Pieteikums atgriezts labošanas režīmā.")
        $scope.reload()
      }, $scope.failing)
    }

    this.mp_improve = () => {
      if (!confirm("Atgriezt pieteikumu labošanai?")) return
      const mp = new MpImprove({ id: dto.id })
      mp.$save((res) => {
        Notification.success("Pieteikums tika atgriezts labošanai, tam izveidota jauna versija.")
        $state.go("app.mp.edit", { id: res.id })
      }, $scope.failing)
    }

    this.mp_set_cfla = (cfla_statuss) => {
      const d = new MpSaveCfla({
        cfla_statuss,
        id: dto.id,
      })
      d.$save(() => {
        Notification.success("CFLA statuss nomainīts")
        $scope.reload()
      }, $scope.failing)
    }

    this.addLigumaIzdevumi = (ligums) => {
      this.editIzdevumi({
        mp_iepirkuma_ligums_id: ligums.id,
        new: true,
      })
    }

    this.addIepirkumaIzdevumi = (ligums) => {
      this.editIzdevumi({
        mp_iepirkuma_ligums_id: ligums.id,
        new: true,
      })
    }

    this.addNesaimnIzdevumiAlga = () => {
      this.editNesaimnIzdevumiAlga({
        new: true,
      })
    }

    this.addCitiIzdevumi = () => {
      this.editIzdevumi({
        new: true,
      })
    }

    this.editNesaimnIzdevumiAlga = (pp) => {
      const p = {
        ...pp,
        iepirkuma_ligumi: undefined,
        kla_budzets: undefined,
        ligumi: undefined,
        pieteikuma_darbibas: undefined,
        budzeta_sadalas_kods: "pers",
        mode: "manual",
      }
      const form = "pages/dialogs/mp.nesaimn.alga.form.html"

      const date_fields = ["apmaksas_datums"]
      date_fields.forEach((dat) => {
        if (p[dat]) p[dat] = new Date(p[dat])
      })

      Dialog.dialog(form, p, { wide: true }, (p, action) => {
        if (action === "delete") {
          return Dialog.finish(new MpRemoveIzdevums({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          const numeric_fields = ["kopeja_summa", "attiec_izdevumi", "attiec_pvn"]
          numeric_fields.forEach((c) => {
            p[c] = p[c] ? +p[c] : undefined
          })
          p.attiec_izdevumi = p.kopeja_summa
          p.attiec_pvn = 0

          return Dialog.finish(new MpEditIzdevums(p), $scope.reload)
        }
      })
    }

    this.editIzdevumi = (pp, form_override = null) => {
      const p = {
        ...pp,
        iepirkuma_ligumi: undefined,
        kla_budzets: undefined,
        ligumi: undefined,
        pieteikuma_darbibas: undefined,
        budzeta_sadalas_kods: undefined, // pers
        mode: "manual",
      }

      const form = form_override ? form_override : "pages/dialogs/mp.izdevums.form.html"

      p.pieteikuma_darbibas = dto.pieteikuma_darbibas
      p.iepirkuma_ligumi = dto.iepirkuma_ligumi
      p.ligumi = dto.citi_ligumi
      p.kla_budzets = dto.kla_budzets

      if (p.mp_iepirkuma_ligums_id) p.mode = "iepirkuma-ligums"

      const date_fields = ["apmaksas_datums"]
      date_fields.forEach((dat) => {
        if (p[dat]) p[dat] = new Date(p[dat])
      })

      Dialog.dialog(form, p, { wide: true }, (p, action) => {
        if (p.mode !== "iepirkuma-ligums") p.mp_iepirkuma_ligums_id = undefined
        if (p.mode === "iepirkuma-ligums") p.mp_ligums_id = undefined

        if (action === "delete") {
          return Dialog.finish(new MpRemoveIzdevums({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          const numeric_fields = ["kopeja_summa", "attiec_izdevumi", "attiec_pvn"]
          numeric_fields.forEach((c) => {
            p[c] = p[c] ? +p[c] : undefined
          })

          p.iepirkuma_ligumi = undefined
          p.kla_budzets = undefined
          p.ligumi = undefined
          p.pieteikuma_darbibas = undefined

          return Dialog.finish(new MpEditIzdevums(p), $scope.reload)
        }
      })
    }

    this.addStdIzdevumi = () => {
      this.editStdIzdevumi({
        new: true,
      })
    }

    this.editStdIzdevumi = (pp) => {
      const p = { ...pp }

      p._budz_changed = (dto, budzets) => {
        console.log({ dto, budzets })
      }

      const form = "pages/dialogs/mp.std-izdevums.form.html"

      if (dto.ar_saimniecisku_darbibu_saistits) {
        p.kla_budzets = { ...Codifiers.kla.budzets_saimn }
      }
      if (!dto.ar_saimniecisku_darbibu_saistits) {
        p.kla_budzets = [
          { id: "isten", nosaukums: "Pētniecības pieteikuma īstenošanas izmaksas" },
          { id: "mob", nosaukums: "Ārvalstu mobilitāte" },
          { id: "mob_fam", nosaukums: "Ģimenes pabalsts mobilitātes laikā" },
          { id: "mob_postdoc", nosaukums: "Pēcdoktoranta pārcelšanās atbalsts" },
          { id: "fam_move", nosaukums: "Ģimenes pabalsts pārcelšanās gadījumā" },
        ]
          .filter((b) => {
            return dto.pieteikuma_budzets.find((pb) => pb.sadala === b.id && pb.attiec)
          })
          .map((b) => {
            if (Codifiers.kla.default_measures[b.id]) {
              return {
                ...b,
                measure: Codifiers.kla.default_measures[b.id][0],
                amount: Codifiers.kla.default_measures[b.id][1],
              }
            }
            return b
          })
      }
      if (p.new && p.kla_budzets.length > 0) {
        p.budzeta_sadalas_kods = p.kla_budzets[0].id
        p.vienibas_izmaksas = p.kla_budzets[0].measure
        p.vienibu_skaits = p.kla_budzets[0].amount
        p.attiec_izdevumi = i(p.vienibas_izmaksas) * i(p.vienibu_skaits)
      }

      Dialog.dialog(form, p, { wide: true }, (p, action) => {
        if (action === "delete") {
          return Dialog.finish(new MpRemoveStdIzdevums({ id: p.id }), $scope.reload)
        } else if (action === "save") {
          p.mp_versija_id = dto.id
          p.vienibas_izmaksas = Codifiers.kla.default_measures[p.budzeta_sadalas_kods][0]
          const numeric_fields = ["vienibas_izmaksas", "vienibu_skaits"]
          numeric_fields.forEach((c) => {
            p[c] = i(p[c])
          })
          p.attiec_izdevumi = p.vienibas_izmaksas * p.vienibu_skaits
          return Dialog.finish(new MpEditStdIzdevums(p), $scope.reload)
        }
      })
    }

    this.setDeleted = () => {
      if (confirm("Izdzēst šo melnrakstu?")) {
        const a = new MpDelete({ id: dto.id })
        a.$save(() => {
          Notification.success("Pieteikums izdzēsts.")
          $state.go(this.goodBackState())
        }, $scope.failing)
      }
    }

    this.tabEnter = (tab) => {
      if (tab.name) $scope.$broadcast(`enter.${tab.name}`)
      if (tab.name === "history") {
        this.onHistoryEnter()
      }
    }

    this.izdevumi_apstipr_changed = (_elem) => {
      let total = 0
      Object.values(dto.kopsavilkums.attiec).forEach((a) => {
        total += i(a.izdevumi_this)
      })
      dto.kopsavilkums.sadalijums.kopa.izdevumi_this = total === 0 ? undefined : total
    }

    this.onHistoryEnter = () => {
      dto.statusi = uuiData.list("mp_statusu_vesture_list", { pieteikums_id: dto.pieteikums_id }, () => {
        const seen = {}
        const uniq = []
        dto.statusi.forEach((s) => {
          if (seen[s.mp_versija_id] === undefined) {
            uniq.push({
              mp_versija_id: s.mp_versija_id,
              current_statuss: s.current_statuss,
            })
            seen[s.mp_versija_id] = true
          }
          s.statuss_html = $filter("formatStatuss")(s.statuss)
        })
        dto.statusi_uniq = uniq
      })
    }

    this.openMP = (id, page) => {
      if ($scope.u.is.manager) {
        $state.go("app.mp.edit", { id, page })
      } else {
        $state.go("app.mp.edit", { id, page })
      }
    }

    this.refreshKopsavilkums = () => {
      const a = new MpRefreshKopsavilkums({ id: dto.id })
      a.$save(() => {
        Notification.success("Kopsavilkuma dati aktualizēti.")
        $scope.reload()
      }).catch($scope.failing)
    }

    // biome-ignore lint/complexity/noUselessLoneBlockStatements: uzraudzības groupings
    {
      /// uzraudzība
      $scope.uzr_upload = {} // uzraudzības dokumenti

      this.uploadUzraudziba = () => {
        const u = $scope.uzr_upload
        u.error = undefined
        console.log(u)

        if (!u.file) {
          u.error = "Ielādējiet kādu failu."
          return
        }
        if (!u.dokumenta_grupas_kods) {
          u.error = "Norādiet arī dokumenta sadaļu."
          return
        }
        if (!u.desc) {
          u.error = "Norādiet arī kādu aprakstu."
          return
        }

        u.loading = true

        return Upload.upload({
          url: "./upload",
          method: "POST",
          file: u.file,
        })
          .progress((evt) => {
            u.progress = {
              loaded: evt.loaded,
              total: evt.total,
              percentage: percentize(evt.loaded, evt.total),
            }
          })
          .success((data) => {
            u.loading = false
            $http({
              method: "POST",
              url: "/data/add_uzraudzibas_dokuments",
              data: {
                id: dto.pieteikums_id,
                file_id: data.id,
                apraksts: u.desc,
                dokumenta_grupas_kods: u.dokumenta_grupas_kods,
              },
            })
              .then(() => {
                document.querySelectorAll(".js-file-upload").forEach((e) => {
                  e.value = ""
                })

                $scope.uzr_upload = { dokumenta_grupas_kods: u.dokumenta_grupas_kods, file: null }
                Notification.success("Uzraudzības dokuments pievienots.")
                $scope.reload()
              })
              .catch((e) => {
                u.loading = false
                u.error = e.data
                Notification.error(u.error)
              })
          })
          .error((e) => {
            u.loading = false
            u.error = e.indexOf("EntityStreamSizeException" > -1) ? "Ielādējamais fails ir par lielu." : e
            Notification.error(u.error)
          })
      }

      this.hasCheckedUzraudzibaAttachments = () => $scope.dto.uzraudzibas_dokumenti.some((n) => n.checked)

      this.removeCheckedUzraudzibaAttachments = () => {
        const att = dto.uzraudzibas_dokumenti.find((n) => n.checked)
        if (att) {
          $http({
            method: "POST",
            url: "/data/remove_uzraudzibas_dokuments",
            data: {
              id: dto.pieteikums_id,
              file_id: att.id,
            },
          })
            .then(() => {
              att.checked = false
              this.removeCheckedUzraudzibaAttachments()
            })
            .catch($scope.failing)
        } else {
          $scope.reload()
        }
      }
    }

    $scope.reload()

    if ($stateParams.page) {
      $scope.dto.$promise.then(() => {
        this.switchToSomeTab($stateParams.page)
      })
    }
  }
)
